import React from 'react';

import { TtsGenderFab } from './TtsGenderFab';
import { TtsVoiceFab } from './TtsVoiceButton';

type Props = {
  showVoices: boolean;
  closeMenu: () => void;
  buttonPopupMenu?: boolean;
  isToggle?: boolean;
  shouldStopAudio?: boolean;
};

export const TtsSelector = ({ showVoices, closeMenu, buttonPopupMenu, isToggle, shouldStopAudio }: Props) => {
  return !showVoices ? (
    <TtsGenderFab menu={true} buttonPopupMenu={buttonPopupMenu} />
  ) : (
    <TtsVoiceFab
      shouldStopAudio={shouldStopAudio}
      isToggle={isToggle}
      closeMenu={closeMenu}
      buttonPopupMenu={buttonPopupMenu}
    />
  );
};
